import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

export default defineNuxtRouteMiddleware(async () => {
	const languageStore = useLanguageStore();
	await languageStore.fetchLocales();
});
